import { apiPost } from "./client";

export async function submitPublicSupportMessage(payload) {
  return apiPost("/support/messages", payload || {});
}
